module.exports = __webpack_public_path__ + "static/media/slider-l6-768.92727b6a.webp";